import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area } from "recharts";
import { CustomTooltip } from "./CustomTooltip";

export const AssetTrend = ({ assetData, capitalInicial, stakingPnl, totalPnlConStaking, rendimiento }) => {
  if (!assetData || !assetData.asset_trend || assetData.asset_trend.length === 0) return null;

  const capital = capitalInicial ? parseFloat(capitalInicial) : assetData.initial_capital;
  const staking = parseFloat(stakingPnl) || 0;
  const capitalFinal = capital + totalPnlConStaking;
  const retorno = rendimiento;

  const customAssetTrend = assetData.asset_trend.map(item => ({
    ...item, asset_value: capital + item.pnl_cumulative + staking
  }));

  const minValue = Math.min(...customAssetTrend.map(d => d.asset_value));
  const maxValue = Math.max(...customAssetTrend.map(d => d.asset_value));
  const padding = (maxValue - minValue) * 0.1 || 1000;

  return (
    <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Tendencia de Activos</h3>
        <div className="flex items-center gap-6 text-sm">
          <div>
            <span className="text-gray-400">Capital Inicial: </span>
            <span className="text-white font-medium">{capital?.toLocaleString()} USDT</span>
          </div>
          <div>
            <span className="text-gray-400">Capital Final: </span>
            <span className={`font-medium ${capitalFinal >= capital ? 'text-emerald-400' : 'text-red-400'}`}>
              {capitalFinal?.toLocaleString(undefined, {maximumFractionDigits: 2})} USDT
            </span>
          </div>
          <div>
            <span className="text-gray-400">Retorno: </span>
            {retorno !== null ? (
              <span className={`font-medium ${retorno >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {retorno >= 0 ? '+' : ''}{retorno?.toFixed(2)}%
              </span>
            ) : (
              <span className="font-medium text-gray-500">--%</span>
            )}
          </div>
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={customAssetTrend}>
            <defs>
              <linearGradient id="colorAsset" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#f59e0b" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f1f23" />
            <XAxis dataKey="date" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} tickFormatter={(v) => v.slice(5)} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} domain={[minValue - padding, maxValue + padding]} tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} />
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" dataKey="asset_value" name="Valor de Activos" stroke="#f59e0b" strokeWidth={2} fillOpacity={1} fill="url(#colorAsset)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
